import './bread.less';

import { Breadcrumb, IBreadcrumbItem } from '@bfe/moly';

const Bread = ({ items }: { items: IBreadcrumbItem[] }) => {
  return (
    <div className="user-service__bread">
      <Breadcrumb items={items} />
      {/* <Breadcrumb separator={<img src={RightArrow} alt="rightArrow" />}>
        {list.map((item, index) => (
          <Breadcrumb.Item key={item.text}>
            {index === list.length || !item.link ? (
              item.text
            ) : (
              <Link to={item.link}> {item.text}</Link>
            )}
          </Breadcrumb.Item>
        ))}
      </Breadcrumb> */}
    </div>
  );
};

export default Bread;
